import axios from 'axios';
import Cookies from 'js-cookie';
import { logger } from './logger';
import { getAccessTokenCookieName, getRefreshTokenCookieName } from './auth-cookies';

const authClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
});

let refreshPromise: Promise<void> | null = null;

export function clearAuthSession(): void {
  Cookies.remove(getAccessTokenCookieName());
  Cookies.remove(getRefreshTokenCookieName());
}

export function redirectToSignIn(): void {
  if (typeof window === 'undefined' || window.location.pathname.startsWith('/signin')) {
    return;
  }

  window.location.assign('/signin');
}

export function expireAuthSession(): void {
  clearAuthSession();
  redirectToSignIn();
}

export async function refreshAccessToken(): Promise<void> {
  refreshPromise ??= authClient
    .post('/auth/refresh')
    .then(() => undefined)
    .catch((error) => {
      expireAuthSession();
      throw error;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}

export async function logoutSession(): Promise<void> {
  try {
    await authClient.delete('/auth/logout');
  } catch (error) {
    logger.error('Ошибка при выполнении logout API:', error);
  } finally {
    clearAuthSession();
  }
}
